import { render, staticRenderFns } from "./MMessageDialog.vue?vue&type=template&id=67b53e90&"
import script from "./MMessageDialog.vue?vue&type=script&lang=js&"
export * from "./MMessageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports